const ENMaps = {
	"ação associada": "associated action",
	"ações associadas": "associated actions",
	"Adicionar Mapa": "Add Map",
	"Alterar Mapa": "Change Map",
	"Até": "Until",
	"Atualizando...": "Updating...",
	"Copiar Mapa": "Copy Map",
	"Dados Gerais": "General Data",
	"Data Inicial é requerida": "Start Date is required",
	"Data Final é requerida": "End Date is required",
	"Descrição é requerida": "Description is required",
	"Deseja realmente excluir o mapa": "Do you really want to delete the map",
	"Desfavoritar": "Disfavor",
	"Digite o nome do Mapa para excluí-lo": "Enter the name of the Map to delete it.",
	"Escolha um mapa para ver os detalhes": "Choose a map to see details",
	"Exclusão do Mapa": "Deleting the Map",
	"Erro ao adicionar mapa": "Error adding map",
	"Erro ao alterar mapa": "Error updating map",
	"Erro ao copiar mapa": "Error copying map",
	"Erro ao atualizar mapas": "Error updating maps",
	"Erro ao buscar mapas": "Error fetching maps",
	"Erro ao desfavoritar mapa": "Error disfavoring map",
	"Erro ao excluir mapa": "Error deleting map",
	"Erro ao favoritar mapa": "Error bookmarking map",
	"Erro ao mover mapa": "Error moving map",
	"estratégia associada": "associated strategy",
	"estratégias associadas": "associated strategies",
	"está atrasada": "is late",
	"está atrasado": "is late",
	"estão atrasadas": "are late",
	"estão atrasados": "are late",
	"Favoritar": "Favorite",
	"Geral": "General",
	"Livro do Plano Estratégico": "Strategic Plan Book",
	"indicador associado": "associated indicator",
	"indicadores associados": "associated indicators",
	"item da SWOT associada": "associated SWOT item",
	"itens da SWOT associadas": "associated SWOT items",
	"Mapa desfavoritado com sucesso": "Successfully disfavored map",
	"Mapa favoritado com sucesso": "Successfully bookmarked map",
	"Mapa Estratégico": "Strategic Map",
	"Mapa adicionado com sucesso": "Map successfully added",
	"Mapa alterado com sucesso": "Map successfully changed",
	"Mapa copiado com sucesso": "Map successfully copied",
	"Mapa excluído com sucesso": "Map successfully deleted",
	"Mapa movido com sucesso": "Map successfully moved",
	"Mapas Atualizados": "Updated Maps",
	"Missão": "Mission",
	"Missão é requerida": "Mission is required",
	"Mostrar Causa x Efeito": "Show Cause x Effect",
	"Mostrar Mapas": "Show Maps",
	"Mover Mapa": "Move Map",
	"Não foi possível carregar as informações": "Unable to load the information",
	"Nenhum mapa selecionado": "No map selected",
	"Nenhuma estratégia vinculada": "No associated strategy",
	"Nome do mapa não confere": "Map name does not match",
	"Notas": "Notes",
	"Novo Mapa": "New Map",
	"Nome é requerido" : "Name is required",
	"Ocultar Causa x Efeito": "Hide Cause x Effect", 
	"Ocultar Mapas": "Hide Maps",
	"Período": "Period",
	"Permissão": "Permission",
	"Permissões": "Permissions",
	"Política de Qualidade": "Quality policy",
	"projeto associado": "associated project",
	"projetos associados": "associated projects",
	"Sem Permissão": "No permission",
	"Selecione um mapa para ver seus detalhes": "Select a map to see its details",
	"Título deve conter no máximo 100 caracteres": "Title must contain a maximum of 100 characters",
	"Valores": "Values",
	"Ver mais": "See more",
	"Ver menos": "See less",
	"Vincular a uma estratégia": "Associate with a strategy",
	"Visão": "Vision",
	"Visão é requerida": "Vision is required",
	"Visualiza": "View",
	"Visualiza e edita": "View and edit",
	"Visualizar Indicadores": "View Indicators",
	"Visualizar Iniciativas": "View Iniciatives",
	"Visualizar Projetos": "View Projects"
};

export default ENMaps;
